export default function FloatingBlobs() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Use smaller blur on mobile for performance */}
      <div className="absolute -top-32 -left-32 w-48 h-48 md:w-96 md:h-96 rounded-full bg-primary/5 blur-2xl md:blur-3xl animate-blob will-change-transform" />
      <div className="absolute -bottom-32 -right-32 w-56 h-56 md:w-[28rem] md:h-[28rem] rounded-full bg-secondary/8 blur-2xl md:blur-3xl animate-blob animation-delay-2000 will-change-transform" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 md:w-80 md:h-80 rounded-full bg-aqua/5 blur-2xl md:blur-3xl animate-blob animation-delay-4000 will-change-transform" />
    </div>
  );
}
